import { buildContext } from "@vega-core/helpers/context/buildContext";

import { useTasksState } from "./useTasksState";

export const {
  ContextProvider: TasksStateProvider,
  useContext: useTasksStateContext,
} = buildContext(useTasksState);
